function isObject (value) {
  return value === Object(value)
}

function isArray (value) {
  return Array.isArray(value)
}

function isFile (value) {
  return value instanceof File
}

function makeArrayKey (key, indice) {
  if (key.length > 2 && key.lastIndexOf('[]') === key.length - 2) {
    return key
  } else {
    return key + '['+ indice +']'
  }
}

function objetoParaFormData(objeto, formData, prefixo) {
  if (!formData) {
    formData = new FormData();
  }

  Object.keys(objeto).forEach(chave => {
    var valor = objeto[chave];

    if (valor === null || valor === undefined) {
      return;
    }

    if (isObject(valor) && !isArray(valor) && !isFile(valor)) {
      objetoParaFormData(valor, formData, chave);
    } else if (isArray(valor)) {
      valor.forEach(function (item, indiceArray) {
        var arrayKey = makeArrayKey(chave, indiceArray)

        if (isObject(item) && !isFile(item)) {
          objetoParaFormData(item, formData, arrayKey)
        } else {
          formData.append(arrayKey, item)
        }
      })
    } else {
      if (prefixo) {
        formData.append(prefixo + '[' + chave + ']', valor);
      } else {
        formData.append(chave, valor);
      }
    }
  });

  return formData;
}

export default objetoParaFormData;



// WEBPACK FOOTER //
// ./FrontEnd/js/converter-objeto-formdata.js